import React, { useEffect, useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import { Get, Put } from '../../utils/httpProvider';
import { JOBGROUP_API } from '../../utils/apiUrl';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

const schema = yup.object().shape({
    name: yup.string().required(messageError.emptyMessage),
    weight: yup.number().min(0, 'Trọng số không thể âm').required(messageError.emptyMessage),
    description: yup.string().nullable()
});

const JobGroupEdit = () => {
    const history = useHistory();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [idJobGroup, setIdJobGroup] = useState('');
    const [jobGroupItem, setJobGroupItem] = useState(null);

    useEffect(() => {
        const paramUrl = new URLSearchParams(location.search.substring(1));
        if (paramUrl.get('id') != null) {
            const id = paramUrl.get('id');
            setIdJobGroup(id);
            setIsLoading(true);
            Get(JOBGROUP_API.GET_ITEM, id, null)
                .then((response) => {
                    setJobGroupItem(response);
                })
                .catch((err) => {
                    toast.error('Không thể lấy thông tin nhóm công việc');
                })
                .finally(() => setIsLoading(false));
        }
    }, []);

    const handleEdit = async (values) => {
        setIsLoading(true);
        try {
            const response = await Put(JOBGROUP_API.UPDATE, idJobGroup, values);
            if (response.status === 200 || response.id) {
                toast.success(messageToast.messageToastUpdateSuccess);
                history.goBack();
            } else {
                toast.error(messageToast.messageToastUpdateError);
            }
        } catch (error) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Sửa Nhóm công việc</Card.Header>
            <Card.Body>
                {jobGroupItem == null ? (
                    <div>Nhóm công việc không tồn tại hoặc đang tải...</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            name: jobGroupItem?.name || '',
                            weight: jobGroupItem?.weight || 0,
                            description: jobGroupItem?.description || ''
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên nhóm công việc *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên nhóm công việc"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Trọng số *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Trọng số"
                                            type="number"
                                            name="weight"
                                            value={values.weight}
                                            onChange={handleChange}
                                            isInvalid={!!errors.weight}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.weight}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Mô tả
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Mô tả"
                                            as="textarea"
                                            rows={3}
                                            name="description"
                                            value={values.description}
                                            onChange={handleChange}
                                            isInvalid={!!errors.description}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.description}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() =>
                                                    history.goBack()
                                                }
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default JobGroupEdit;
